
/**
 * @export
 * @enum {string}
 */
export enum SetUpStep {
    START_STEP = 'START_STEP',
    SELECT_IDP = 'SELECT_IDP',
    VERIFY_DOMAIN = 'VERIFY_DOMAIN',
    SP_METADATA = 'SP_METADATA',
    USER_ATTRIBUTES = 'USER_ATTRIBUTES',
    IDP_METADATA = 'IDP_METADATA',
    TEST_CONNECTION = 'TEST_CONNECTION',
    REVIEW_AND_ENFORCE = 'REVIEW_AND_ENFORCE'
}